import { render, staticRenderFns } from "./JcdcExportBtn.vue?vue&type=template&id=629f2e7b&scoped=true"
import script from "./JcdcExportBtn.vue?vue&type=script&lang=ts"
export * from "./JcdcExportBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629f2e7b",
  null
  
)

export default component.exports